module.exports = __webpack_public_path__ + "static/fonts/Gilroy-Medium.5c1e5748.otf";